// extracted by mini-css-extract-plugin
module.exports = {"root":"Skills_root__2UbUI"};